import React from "react";
import Typography from "@material-ui/core/Typography";
import { Grid } from "@material-ui/core";
import AntSwitch from "../EditEquipmentModal/AntSwitch";
import Collapse from "@material-ui/core/Collapse";
import { makeStyles } from "@material-ui/core/styles";
import { TemperaturesSectionProps } from "./interfaces/TemperaturesSectionProps";
import { TemperatureFormController } from "./TemperatureFormController";
import { useTranslation } from "react-i18next";

export const useStyles = makeStyles(() => ({
  disabled: {
    pointerEvents: 'none',
  },
}));

function TemperaturesSection({
    isRequired,
    setIsRequired,
    name,
    temperatures,
    setTemperatures,
    errorValidations,
    setErrors,
    disabled = false,
    type
}: TemperaturesSectionProps) {

  const { t } = useTranslation();
  const showDisabledTemps = disabled && !temperatures.tempMin && !temperatures.tempMax;
  const handleSwitchChange = () => {
    if (showDisabledTemps) {
      return;
    }

    if (setIsRequired) {
      setIsRequired(!isRequired);
    }
    if(!isRequired &&setErrors){
       setErrors({})
    }
  };
  return (
    <Grid container>
      <Grid item xs={6}>
        <Typography variant="h6" color="initial">
          {name}
        </Typography>
      </Grid>
      {setIsRequired && (
        <>
          <Grid item xs={1} style={{ marginTop: 6 }}>
            <Typography variant="caption">
              {t('app.common.required')}{' '}
            </Typography>
          </Grid>
          <Grid item xs={5} style={{alignContent: 'start'}}>
            <div style={{marginTop: 10}}>
              <AntSwitch checked={isRequired} onChange={handleSwitchChange}/>
            </div>
          </Grid>
          </>
        )}
        <Grid item xs={12}>
          <div style={{height: 20}}/>
        </Grid>
        { <Collapse in={isRequired} style={{width: '100%'}}>
            <TemperatureFormController
              temperatures={temperatures}
              setTemperatures={setTemperatures}
              type={type}
              errorValidations={errorValidations}
              setErrors={setErrors}
              disabled={disabled}
            />
          </Collapse>
        }
    </Grid>
  );
}

export default TemperaturesSection;
